import React, { useState, useEffect } from 'react';
import {useNavigate, useParams, useLocation} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimes, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import {take} from "rxjs";
import i18next from 'i18next';

function ActivateAccountEmail({userService}) {
  const { token } = useParams();
  const [windowWidth, setWindowWidth] = useState(0);
  const [activeShow, setActiveShow] = useState(false);
  const [emailActivated, setEmailActivated] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const updateWindowDimensions = () => {
      setWindowWidth(window.innerWidth);
    };

    updateWindowDimensions();
    window.addEventListener('resize', updateWindowDimensions);

    const sub = userService.activateAccountWithTokenHasFailed.pipe(take(1)).subscribe((status) => {
      setEmailActivated(!status);
    });
    userService.doValidateToken(token);

    return () => {
      window.removeEventListener('resize', updateWindowDimensions);
      sub.unsubscribe();
    };
  }, [token, userService]);

  useEffect(() => {
    if (location?.state?.show !== undefined) {
      setActiveShow(location.state.show);
    }
  }, [location]);

  return (
      <React.Fragment>
        {windowWidth > 767 ? (
            <div className={'activate-account-email-desktop'}>
              <div>
                <div className={'header-popup flex space-between'}>
                  <p className={'p0 accent-color m-0'}>{i18next.t('Attiva il tuo account')}</p>
                  <div>
                    <FontAwesomeIcon icon={faTimes}
                                     className={'light-grey pointer'}
                                     onClick={() => navigate('/')}
                    />
                  </div>
                </div>
                <div className={'body-popup controla-email center'}>
                  {emailActivated ?
                      <FontAwesomeIcon icon={faCheckCircle} className={'check-circle'} /> :
                      <FontAwesomeIcon icon={faTimesCircle} className={'x-circle'} />
                  }
                  <p className={'ptb-10 m-0'}>
                    {emailActivated ? i18next.t('Il tuo account e\' stato attivato!') : i18next.t('E\' stato un problema')}
                  </p>
                  <div className={'button'}>
                    <div className={'test-button'} onClick={() => navigate('/')}>{i18next.t('CHIUDI')}</div>
                  </div>
                </div>
                <div className={'footer-popup'}>
                  {!emailActivated &&
                      <p className={'p0'}>{i18next.t('Contatta il')}{' '}<span>{i18next.t('Support')}</span>{' '}{i18next.t('per attivare l\'account.')}</p>
                  }
                </div>
              </div>
            </div>
        ) : (
            <div className={'activate-account-email-mobile ' + (activeShow ? 'active' : '')}>
              <div>
                <div className={'header-popup flex space-between'}>
                  <p className={'p0 m-0 light-grey p20'}>{i18next.t('Attiva il tuo account')}</p>
                  <div>
                    <FontAwesomeIcon icon={faTimes}
                                     className={'light-grey pointer'}
                                     onClick={() => navigate('/')}
                    />
                  </div>
                </div>
                <div className={'body-popup controla-email center'}>
                  {emailActivated ?
                      <FontAwesomeIcon icon={faCheckCircle} className={'check-circle'} /> :
                      <FontAwesomeIcon icon={faTimesCircle} className={'x-circle'} />
                  }
                  <p className={'ptb-10 m-0'}>
                    {emailActivated ? i18next.t('Il tuo account e\' stato attivato!') : i18next.t('E\' stato un problema')}
                  </p>
                </div>
              </div>
              <div>
                <div className={'button-wrapper mb-10'}>
                  <div className={'button'} onClick={() => navigate('/login')}>{i18next.t('LOGIN')}</div>
                </div>
                <div className={'button-wrapper'}>
                  <div className={'button p14 pink-bg white'} onClick={() => navigate('/')}>{i18next.t('ESCI')}</div>
                </div>
              </div>
            </div>
        )}
      </React.Fragment>
  );
}

export default ActivateAccountEmail;
